import { createContext, useContext } from 'react';

type DefinitionContextType = {
  definition: string;
};

export const DefinitionContext = createContext<DefinitionContextType>(
  {} as DefinitionContextType,
);

export const useDefinition = (): DefinitionContextType =>
  useContext(DefinitionContext);
